import mixpanel from 'mixpanel-browser'
import { useEffect } from 'react'

import { Button } from './Button'
import { Input } from './Input'

import { useFormValidation } from '../hooks/UseFormValidation'

interface GetStartedProps {
  error: string
  handleUrl: (value: string) => void
}

export function GetStarted({ handleUrl, error }: GetStartedProps) {
  useEffect(() => {
    if (error) {
      formValidator.setCustomError(error)
    }
  }, [error])

  useEffect(() => {
    mixpanel.track('EnterYourURLScreenViewed')
  }, [])

  const formValidator = useFormValidation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    handleUrl(formValidator.value)
  }

  return (
    <div className='mx-auto max-w-4xl flex-grow flex items-center min-h-0'>
      <div className='text-center w-full py-4'>
        <h1 className='animate-slidein300 font-serif opacity-0 text-balance text-4xl md:text-5xl lg:text-[54px] font-medium tracking-tight text-dw-black font-semibold'>
          Setting Up Your <span className='text-dw-gold'>Web Wisdom</span>
        </h1>
        <p className='animate-slidein500 opacity-0 mt-8 text-pretty text-m font-medium text-gray-600 sm:text-xl/8'>
          We’re creating your personalized Web Wisdom—this will just take a
          moment.
        </p>
        <div className='animate-slidein700 opacity-0 mt-16 flex items-center justify-center gap-x-6 '>
          <form
            onSubmit={handleSubmit}
            className='w-full lg:col-span-5 lg:pt-2'
          >
            <div className='flex gap-x-4 flex-col max-w-2xl mx-auto'>
              <label
                htmlFor='url'
                className='text-2xl sm:text-4xl font-serif tracking-tight font-semibold'
              >
                Enter your website URL
              </label>
              <div className='h-[50px] mt-9 p-1 bg-white flex gap-x-2 rounded-[14px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-600'>
                <Input
                  id='url'
                  name='url'
                  inputMode='url'
                  autoCapitalize='none'
                  placeholder='Enter URL here'
                  value={formValidator.value}
                  onInputChange={formValidator.handleChange}
                  className='outline-none'
                />

                <Button
                  type='submit'
                  title='Get Started'
                  className='bg-dw-yellow-accent hover:bg-dw-gold focus-visible:outline-dw-gold'
                />
              </div>
              <div className='h-5'>
                {formValidator.error && (
                  <div className='text-red-500 text-sm text-left'>
                    {formValidator.error}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
